import { createDataHook } from 'next-data-hooks';
import sdk from '../../../lib/sdk';

const useAboutData = createDataHook('AboutData', async () => {
  const [aboutData, mainImage] = await Promise.all([
    sdk.allAbout(),
    sdk.mainImageUrl(),
  ]);

  return {
    aboutMeData: aboutData.allAboutMe[0],
    mainImageUrl: mainImage.allHomepage[0].desktopImage?.asset?.url ?? '',
  };
});

export default useAboutData;
